import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/misc/pageContext';

export const MiscContentDetailsErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for MiscContentDetails page (error: ${error})`);
};
